import * as React from "react";
import get from "lodash/get";

import "./Coupons.css";
import { isEditMode } from "../../utils/sendClickToMerchant";
import { getCoupons } from "../../reducers/reward/methods";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface CouponsProps extends ComponentBaseProps {
  classNames: string;
  name: string;
  configName: string;
  couponStyle: React.CSSProperties;
  distributedContent: string;
  redeemedContent: string;
  style?: React.CSSProperties;
  redeemedStyle?: React.CSSProperties;
  distributedStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
  coupons: ReturnType<typeof getCoupons>;
}

export class Coupons extends ComponentBase<CouponsProps> {
  render() {
    const {
      classNames,
      couponStyle,
      distributedContent,
      distributedStyle,
      dividerStyle,
      redeemedContent,
      redeemedStyle,
      style,
    } = this.props;

    const coupons = isEditMode() ? exampleCoupons : this.props.coupons || [];

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        className={`Coupons-container ${classNames || ""}`}
        style={{ ...style, maxHeight: get(style, "height", "inherit") }}
        aria-label="Referrals History"
        ref={(component) => (this.component = component)}
      >
        {coupons.map((coupon) => {
          return (
            <React.Fragment key={coupon.coupon}>
              <div className="Coupons-item">
                <div className="Coupons-details">
                  <div style={{ ...couponStyle }}>{coupon.coupon}</div>
                </div>
                {coupon.status === "redeemed" && (
                  <div style={distributedStyle}>
                    {redeemedContent || "Redeemed"}
                  </div>
                )}
                {coupon.status === "distributed" && (
                  <div>
                    <div style={redeemedStyle}>
                      {distributedContent || "Not used"}
                    </div>
                  </div>
                )}
              </div>
              <div className="Coupons-divider" style={dividerStyle} />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const exampleCoupons = [
  {
    coupon: "FBUY-20-1",
    status: "distributed",
  },
  {
    coupon: "FBUY-20-2",
    status: "distributed",
  },
  {
    coupon: "FBUY-20-3",
    status: "redeemed",
  },
  {
    coupon: "FBUY-20-4",
    status: "redeemed",
  },
  {
    coupon: "FBUY-20-5",
    status: "redeemed",
  },
];
